import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, ordersActions, getNicheById, getOrderHistory } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersActions, {
  [getNicheById.fulfilled]: (state, { payload }) => {
    state.niche = payload;
  },
  [getNicheById.rejected]: (state) => {
  },
  [getOrderHistory.fulfilled]: (state, { payload }) => {
    state.orderHistories = payload.results;
  },
  [getOrderHistory.rejected]: (state) => {
  },
});

export default slice.reducer;
